module.exports = __webpack_public_path__ + "files/beep.39aebb810d180531dab8716f285ae25f.wav";